import { forwardRef } from 'react';
import { TextField } from '@mui/material';
import { DesktopTimePicker } from '@mui/x-date-pickers';
import { FieldProps, getIn } from 'formik';

type FieldTimePickerProps = FieldProps &
  Partial<{
    required?: boolean;
    label?: string;
  }>;

export const FieldTimePicker = forwardRef<HTMLDivElement, FieldTimePickerProps>(
  function FieldTimePicker(
    {
      required = false,
      label,
      field,
      form: { errors, touched, setFieldValue, setFieldTouched },
      ...props
    },
    ref,
  ) {
    const { name } = field;
    const errorMessage = getIn(errors, name);
    const isTouched = !!getIn(touched, name);

    return (
      <DesktopTimePicker
        ref={ref}
        label={label}
        ampm={false}
        {...field}
        onChange={(value) => {
          setFieldValue(name, value, true);
          setFieldTouched(name, true);
        }}
        {...props}
        renderInput={(params) => (
          <TextField
            name={name}
            {...params}
            type="tel"
            error={isTouched && !!errorMessage}
            helperText={isTouched && (errorMessage as string)}
            fullWidth
            required={required}
          />
        )}
      />
    );
  },
);
